import * as types from 'reducer/actionTypes'

const initialState = {
	data:{},
	errorLabel:{},
	error:null
};

export default function account(state = initialState, action){
	switch(action.type){

		case types.SET_ACCOUNT_ERRORLABEL:
			return{
				...state,
				errorLabel: action.errorLabel,
			}

		// fetch success
		case types.FETCH_I18N_LANGUAGE_SUCCESS:
			return{
				...state,
				error: initialState.error
			}

		case types.FETCH_GET_ACCOUNT_INFO_SUCCESS:
			return{
				...state,
				data:action.value,
				errorLabel: initialState.errorLabel,
				error: initialState.error
			}

		case types.FETCH_GET_ACCOUNT_LANGUAGE_SUCCESS:
			return{
				...state,
				error: initialState.error
			}

		case types.FETCH_SET_ACCOUNT_CHANGE_USERID_SUCCESS:
			return{
				...state,
				error: initialState.error
			}

		case types.FETCH_SET_ACCOUNT_CHANGE_PASSWORD_SUCCESS:
			return{
				...state,
				error: initialState.error
			}

		////////////FETCH
		case types.FETCH_I18N_LANGUAGE_FAILURE:
			return{
				...state,
				error: action.error
			}

		case types.FETCH_GET_ACCOUNT_INFO_FAILURE:
			return{
				...state,
				error: action.error
			}

		case types.FETCH_GET_ACCOUNT_LANGUAGE_FAILURE:
			return{
				...state,
				error: action.error
			}

		case types.FETCH_SET_ACCOUNT_CHANGE_USERID_FAILURE:
			return{
				...state,
				error: action.error
			}

		case types.FETCH_SET_ACCOUNT_CHANGE_PASSWORD_FAILURE:
			return{
				...state,
				error: action.error
			}

		default:
			return state
	}
}